/** @format */

import React from "react";
import ArrowRight from "../SvgIcons/ArrowRight";
import { Link } from "react-router-dom";
import "./style.scss";
import Logo from "../SvgIcons/Logo";
import FaceBook from "../SvgIcons/FaceBook";
import Instagram from "../SvgIcons/Instagram";
import Youtube from "../SvgIcons/Youtube";
import MailchimpSubscribe from "../MailChimpForm";

export default function Footer() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <footer>
      <div className='container'>
        <div className='footer-box'>
          <div className='footer-top' data-aos='fade-in'>
            <h3 className='signuptooter'>Sign up for the latest updates</h3>
            <div className='mailer'>
              <label>Newsletter</label>
              <MailchimpSubscribe />
            </div>
          </div>
          <div className='footer-bottom'>
            <div className='footerrlogo'>
              <Link className='bottomlogo' to='/' onClick={handleClick}>
                <Logo />
              </Link>
              <ul>
                <li>
                  <Link
                    to='https://www.facebook.com/share/15ngXRVfVq/'
                    target='_blank'
                  >
                    <FaceBook />
                  </Link>
                </li>
                <li>
                  <Link
                    target='_blank'
                    to='https://www.instagram.com/getpaths/?igsh=MW1mc3RzejFzc3JsZw%3D%3D#'
                  >
                    <Instagram />
                  </Link>
                </li>
                <li>
                  <li>
                    <Link
                      target='_blank'
                      to='https://www.youtube.com/@paths8745'
                    >
                      <Youtube />
                    </Link>
                  </li>
                </li>
              </ul>
            </div>
            <div className='footermenu'>
              <strong>Company</strong>
              <ul>
                <li>
                  <Link to='/privacy-model' onClick={handleClick}>
                    Privacy Model
                  </Link>
                </li>
                <li>
                  <Link to='/legal-privacy-policy' onClick={handleClick}>
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to='/terms-of-Service' onClick={handleClick}>
                    Terms of Use
                  </Link>
                </li>
              </ul>
            </div>
            <div className='footermenu'>
              <strong>About</strong>
              <ul>
                <li>
                  <Link to='/about' onClick={handleClick}>
                    About
                  </Link>
                </li>
                <li>
                  <Link to='/mission' onClick={handleClick}>
                    Mission
                  </Link>
                </li>
                {/* <li>
                  <Link to="/vision" onClick={handleClick}>
                    Vision
                  </Link>
                </li> */}
              </ul>
            </div>
            <div className='footermenu'>
              <strong>Help</strong>
              <ul>
                <li>
                  <Link to='/contact' onClick={handleClick}>
                    Contact
                  </Link>
                </li>
                <li>
                  <Link
                    to='https://docs.google.com/forms/d/e/1FAIpQLSfWYDeIHWj07TtQOTqGUo5I_p0yB2H8RMBpW4NQge-qZze7Tg/viewform'
                    target='_blank'
                  >
                    Bugs/Feedback
                  </Link>
                </li>
                <li>
                  <Link to='/faqs' onClick={handleClick}>
                    FAQ’s
                  </Link>
                </li>
              </ul>
            </div>
            <div className='foterapps'>
              <h4>
                Download <span>the App Now!</span>
              </h4>
              <div className='playstore'>
                <Link
                  to='https://apps.apple.com/us/app/paths-friends-memories-life/id1480890359'
                  target='_blank'
                >
                  <img
                    src='../images/android.png'
                    alt='android'
                    className='img-fluid'
                  />
                </Link>
                <Link
                  to='https://play.google.com/store/apps/details?id=com.getpaths.paths'
                  target='_blank'
                >
                  <img
                    src='../images/googlepaly.png'
                    alt='googlepaly'
                    className='img-fluid'
                  />
                </Link>
              </div>
            </div>
          </div>
          <div className='copyright'>
            © {new Date().getFullYear()}, Paths™ "Seize life and Share it™".
          </div>
        </div>
      </div>
    </footer>
  );
}
